/// <reference path="../interfaces/MasterSlider.ts" />

module Elma.ViewModels {
    export class FrontpageViewModel extends Tapas.ViewModels.FrontpageViewModel {
        public sliderConfig: IMasterSlider.ISliderParams;
        public username: KnockoutObservable<string>;
        public password: KnockoutObservable<string>;
        public sliderWidth = ko.observable(2100); // made it possible to change via initvalue
        public sliderHeight = ko.observable(574); // made it possible to change via initvalue

        constructor() {
            super();     

            if (window.matchMedia) {
                if (window.matchMedia("max-width: 1024px").matches && window.matchMedia("min-width: 992px").matches) {
                    this.sliderWidth(1024);
                    this.sliderHeight(360);
                } else if(window.matchMedia("max-width: 767px").matches) {
                    this.sliderWidth(758);
                    this.sliderHeight(570);
                }
            }

            this.sliderConfig = {
                width: this.sliderWidth(),
                height: this.sliderHeight(),
                fillMode: "fill",
                layout: "fullwidth",
                autoplay: true,
                controls: {
                    bullets: {
                        autohide: false,
                        dir: "h",
                        margin: 0,
                        hideUnder: 900
                    }
                }
            };
        }
    }
}